export default {

    computed: {

    },

    methods: {


		_timeToDecimal(dtInicio, dtFim){

			var dec = moment(dtInicio, $sessao.getDateFormat()+ ' HH:mm').locale(this._getLangDp)
			var pouso = moment(dtFim, $sessao.getDateFormat()+ ' HH:mm').locale(this._getLangDp)

			var diff = pouso.diff(dec)
			var duration = moment.duration(diff)

			var $hours   = duration.hours()
			var $days   = duration.days()
			var $minutes = duration.minutes()

			if($hours == 0 && $days == 0 && $minutes == 0){
				return 0.0
			}
			
			var $decimo_hora = 0;
					
			if ($minutes >= 4 && $minutes <= 9)
			{
				$decimo_hora = 1;
			} 
			else if ($minutes >= 10 && $minutes <=15)
			{
				$decimo_hora = 2;
			}
			else if ($minutes >= 16 && $minutes <=21)
			{
				$decimo_hora = 3;
			}
			else if ($minutes >= 22 && $minutes <=27)
			{
				$decimo_hora = 4;
			}
			else if ($minutes >= 28 && $minutes <=33)
			{
				$decimo_hora = 5;
			}
			else if ($minutes >= 34 && $minutes <=39)
			{
				$decimo_hora = 6;
			}
			else if ($minutes >= 40 && $minutes <=45)
			{
				$decimo_hora = 7;
			}
			else if ($minutes >= 46 && $minutes <=51)
			{
				$decimo_hora = 8;
			}
			else if ($minutes >= 52 && $minutes <=57)
			{
				$decimo_hora = 9;
			}
			else if (($minutes >= 58))
			{
				$decimo_hora = 0;
				$hours++;           
			}
			else if ($hours != 0)
			{
				$decimo_hora = 0;
				
			}else
			{
				$decimo_hora = 0;
			}
						
			return Number($hours + ($days * 24))+'.'+ $decimo_hora;
		},

		_somaTempos(tempo1, tempo2, tempo3){

			let tp1 = tempo1.split(":")
			let tp2 = tempo2.split(":")
			let tp3 = '00:00'.split(":")
			if(!_.isNil(tempo3)){
				tp3 = tempo3.split(":")
			} 

			let hora = Number(tp1[0]) + Number(tp2[0]) + Number(tp3[0])

			let min = Number(tp1[1]) + Number(tp2[1]) + Number(tp3[1])

			if(min >= 60){
				hora += 1
				min = min - 60 
			}

			return (hora < 10 ? '0' + hora: hora) +':'+ (min < 10 ? '0' + min: min)
		},


        _round(value, precision) {
			var multiplier = Math.pow(10, precision || 0);
			return Math.round(value * multiplier) / multiplier;
		},

		_convertDD(value, tipo) {   

			var degrees, minutes, seconds, direction = 0

			if(tipo == 'lng'){
				direction = value.substring(0, 1);
				degrees = value.substring(1, 4);
				minutes = value.substring(5, 7);
				seconds = value.substring(8, 10);
			}


			if(tipo == 'lat'){
				direction = value.substring(0, 1);
				degrees = value.substring(1, 3);
				minutes = value.substring(4, 6);
				seconds = value.substring(7, 9);
			}

			var dd = Number(degrees) + Number(minutes)/60 + Number(seconds)/(60*60);
		
			if (direction.toUpperCase() == "S" || direction.toUpperCase() == "W") {
				dd = dd * -1;
			} // Don't do anything for N or E
			return dd;
		},

		_convertDMS( lat, lng ){
		
			var lat = lat;
			var lng = lng;
			var latResult, lngResult;
			var dmsResult = {};

			lat = parseFloat(lat);  
			lng = parseFloat(lng);

			latResult = (lat >= 0)? 'N' : 'S';

			// Chamada à função getDms(lat) para as coordenadas da Latitude em DMS.
			// O resultado será adicionado à variável latResult.
			latResult += this._getDms(lat, 'lat');

			lngResult = (lng >= 0)? 'E' : 'W';

			// Chamada à função getDms(lng) para as coordenadas da Longitude em DMS.
			// O resultado será adicionado à variável lngResult.
			lngResult += this._getDms(lng, 'lng');

			// Agora é só juntar as duas variáveis e separá-las com um espaço.
			dmsResult.lat = latResult;
			dmsResult.lng = lngResult;

			// Devolvendo a string
			return dmsResult;
		},
			
		_getDms (val, tipo) {

			var valDeg, valMin, valSec, result;

			val = Math.abs(val);

			var pad = '00'
			var padGraus = '00'

			if(tipo == 'lng'){
				padGraus = '000'
			}

			valDeg = Math.floor(val) + '';
			result = (padGraus + valDeg).slice(-padGraus.length) + "º";

			valMin = Math.floor((val - valDeg) * 60) + '';
			result += (pad + valMin).slice(-pad.length) + "'";

			valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000;

			var auxSec = Number(valSec).toFixed(0)

			if(auxSec >= 60){
				auxSec = 59
			}

			result += (pad + auxSec + '').slice(-pad.length) + '';

			return result;
		},

		_calculaPouso(inicio, tempo){

			var init = inicio.split(":")
			var initH = Number(init[0])
			var initM = Number(init[1])

			var temp = tempo.split(":")
			var tempH = Number(temp[0])
			var tempM = Number(temp[1])
			var tempS = Number(temp[2])

			var sumMin = tempM + initM

			if(sumMin >= 60){
				sumMin = sumMin - 60
				tempM += 1
			}

			var sumHora = tempH + initH

			if(sumHora >= 24){
				sumHora = sumHora - 24
			}

			return  sumHora +':'+ sumMin + ':'+ tempS

		},

		_calculaTempo(tempo){
			var hora = Math.trunc(tempo);
			var minuto = Math.trunc((tempo - hora) * 60)
			var segundo = Math.ceil((tempo - hora - minuto / 60)*3600)

			return hora + ":" + minuto + ":" + segundo;
		},

		_carregaDiarioExterno(idDiario, nomeReduzido, callback){
			

			var url = '/Relatorio_voo_trecho/get/'+ idDiario

			if(nomeReduzido != null){
				url = nomeReduzido + url
			}

			this._httpGet(url, (response) => {

				if(response._request){
					this._providerAeronave((lista) => {

						var aero = _.find(lista, o => { return o.id == response.lista.id_aeronave })

						var item = {
							id: response.lista.id,
							_dataAcionamento : this._SQLDateToDateTime(response.lista.acionamento, $sessao.getDateFormat() + ' HH:MM'),
							_dataCorte : this._SQLDateToDateTime(response.lista.corte, $sessao.getDateFormat() + ' HH:MM'),
							tempo_voo: response.lista.tempo_voo,
							numero_diario: response.lista.numero_diario,
							tempo_voo_motor: response.lista.tempo_voo_motor,
							tempo_voo_celula: response.lista.tempo_voo_celula,
							_diario_de_bordo: response.lista
						}

						callback({trecho: item, aero: aero})
					})
				}
			})
		},

		_calculaProa(callback, lat1, lon1, lat2, lon2){

			// Δφ = ln( tan( latB / 2 + π / 4 ) / tan( latA / 2 + π / 4) ) 
			// Δlon = abs( lonA - lonB ) 
			// rolamento :  θ = atan2( Δlon ,  Δφ ) 

			var startLat = Math.radians(lat2)
			var startLong = Math.radians(lon2)
			var endLat = Math.radians(lat1)
			var endLong = Math.radians(lon1)

			var dLong = endLong - startLong

			var dPhi = Math.log(Math.tan(endLat/2.0+Math.PI/4.0)/Math.tan(startLat/2.0+Math.PI/4.0))
			if (Math.abs(dLong) > Math.PI){
				if (dLong > 0.0)
					dLong = -(2.0 * Math.PI - dLong)
				else
					dLong = (2.0 * Math.PI + dLong)
			}

			var bearing = (Math.degrees(Math.atan2(dLong, dPhi)) + 360.0) % 360.0;

			var self = this
			//console.log("lat orgao", lat2, lon2)
			$.get(this.getURL_WS('/Servico/get_vmm/' + lat2 +'/'+ lon2), function(response){
				try {
					var value = Math.abs(Number(retorno['geomagnetic-field-model-result']['field-value']['declination']['value']))
					//console.log(value)
					var valor = bearing + Math.round(value)
					//console.log(valor)

					if(valor >  360){
						callback(valor - 360)
						return valor - 360
					} else {
						callback(valor)
					}
				} catch(ex){
					callback(bearing)
				}

			}).fail(function(){
				callback(bearing)
			})

			/*
			this._httpGet('/Servico/get_vmm/' + lat2 +'/'+ lon2, function(retorno){
				try {
					var value = Math.abs(Number(retorno['geomagnetic-field-model-result']['field-value']['declination']['value']))
					//console.log(value)
					var valor = bearing + Math.round(value)
					//console.log(valor)

					if(valor >  360){
						callback(valor - 360)
						return valor - 360
					} else {
						callback(valor)
					}
				} catch(ex){
					callback(bearing)
				}
			}) */
		},

		_calculaDistancia(lat1, lon1, lat2, lon2) {
			var RADIUSMILES = 3963.191,
			RADIUSKILOMETERS = 6373,
			latR1 = this.deg2rad(lat1),
			lonR1 = this.deg2rad(lon1),
			latR2 = this.deg2rad(lat2),
			lonR2 = this.deg2rad(lon2),
			latDifference = latR2 - latR1,
			lonDifference = lonR2 - lonR1,
			a  = Math.pow(Math.sin(latDifference / 2), 2) + Math.cos(latR1) * Math.cos(latR2) * Math.pow(Math.sin(lonDifference / 2), 2),
			c  = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
			dm = c * RADIUSMILES,
			dk = c * RADIUSKILOMETERS
			return  dm * 0.868976
		},


		_calculaDistanciaKM(lat1, lon1, lat2, lon2) {
			var RADIUSMILES = 3963.191,
			RADIUSKILOMETERS = 6373,
			latR1 = this.deg2rad(lat1),
			lonR1 = this.deg2rad(lon1),
			latR2 = this.deg2rad(lat2),
			lonR2 = this.deg2rad(lon2),
			latDifference = latR2 - latR1,
			lonDifference = lonR2 - lonR1,
			a  = Math.pow(Math.sin(latDifference / 2), 2) + Math.cos(latR1) * Math.cos(latR2) * Math.pow(Math.sin(lonDifference / 2), 2),
			c  = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
			dm = c * RADIUSMILES,
			dk = c * RADIUSKILOMETERS
			return  dk
		},

		deg2rad(deg) {
			var rad = deg * Math.PI / 180;
			return rad;
		},
    }
}